import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useRevealOnScroll } from "@/hooks/useReveal";
import SongHero from "./components/SongHero";
import SongGuide from "./components/SongGuide";
import SongForm from "./components/SongForm";

export default function Song() {
  useRevealOnScroll();

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <SongHero />
        <SongGuide />
        <SongForm />
      </main>
      <Footer />
    </div>
  );
}